<template>
    <!-- 升学途径 升学途径分析测试入口-->
    <div class="analysis_test_entry">
        <div class="banner">
            <img src="/imgs/wayToStudy/analysis_test/banner.png" alt="">
        </div>
        <div class="content">
            <div class="main">
                <p>新高考背景下升学途径已经增至20多种，通过裸分统招升入名校的难度增加，而其他升学途径的招生规模还会扩容，这对高中生的有效备考和升学规划提出了新的要求。为了更顺利地升入理想院校，学生和家长需要了解各种升学途径的要求，根据自身特点和条件进行定位和规划。基于此，本系统评估帮助你初步探索可行的升学途径。</p>
                
            </div>
            <div class="notice">
                <h6>测前须知</h6>
                <ol>
                    <li>1、请务必根据自身情况如实回答问题，以保证评估结果的有效性；</li>
                    <li>2、评估通过科学、系统的方法为考生和家长提供相对可靠、全面的数据，重点在于发现更多的升学可能，而不在于限制学生选择；</li>
                    <li>3、评估通常情况下是根据真实作答数据帮助考生获得匹配的结果，可作为初步升学方向，而非最终升学决策。</li>
                </ol>
            </div>
            <div class="btn_start">
                <div class="btn" @click="$router.push('/wayToStudyWays/testmain')">开始测评</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
    name: 'analysis_test_entry',
    data() {
        return {
        }
    },
    methods: {
        change(url) {
            this.$router.push(url);
            window.scrollTo(0, 0);
        }
    },
    created() {
        
    }
}
</script>
<style type="text/css" lang='less' scoped>
.analysis_test_entry {
    height: 800px;
    .banner {
        position: relative;
        z-index: 2;
        > img{
            width: 100%;
        }
    } 
    .content {
        height: 624px;
        box-sizing: border-box;
        padding: 40px 20px 40px 20px;
        background-color: #fff;
        position: relative;
        border-radius: 5px;
        color: #333;
        top: -20px;
        z-index: 1;
        .main {
            p {
                font-size: 14px;
                text-indent: 2em;
                line-height: 24px;
                margin-bottom: 20px;
            }
        }
        .notice {
            padding-left: 30px;
            height: 150px;
            border: 2px dashed #aecefe;
            h6 {
                padding-left: 38px;
                line-height: 50px;
                margin-bottom: 5px;
                font-size: 17px;
                font-weight: 600;
                color: #3c91f4;
                background: url(/imgs/wayToStudy/analysis_test/icon_tishi.png) no-repeat 0px center;
            }
            ol {
                li {
                    font-size: 12px;
                    line-height: 24px;
                }
            }
        }
    }
    .btn_start {
        padding-top: 30px;
        .btn {
            width: 100px;
            height: 36px;
            cursor: pointer;
            line-height: 36px;
            color: #fff;
            border: none;
            border-radius: 3px;
            margin: 0 auto;
            background-color: #3c91f4;
            &:active {
                background-color: #136ed8;
            }
        }
    }
}
</style>